module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "finish"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('button', {
    staticStyle: {
      "background": "#93DACA"
    },
    on: {
      "click": function($event) {
        _vm.goFun(0)
      }
    }
  }, [_vm._v("继续布置")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.goFun(1)
      }
    }
  }, [_vm._v("查看作业")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selectHead"
  }, [_vm._v("\n    布置作业\n    "), _c('div', {
    staticClass: "stepBar fr"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/step3.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "active"
  }, [_vm._v("布置对象")]), _vm._v(" "), _c('span', {
    staticClass: "active"
  }, [_vm._v("选择内容")]), _vm._v(" "), _c('span', {
    staticClass: "active"
  }, [_vm._v("作业留言")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/new icon/success.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("您的作业已经发布成功！")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f2dad5bc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/publishFinish/publishFinish.vue
// module id = 1250
// module chunks = 1